export const maxLength = (chartContext: {
  w: { config: { series: { data: any[] }[] } };
}) => {
  const {
    w: {
      config: { series },
    },
  } = chartContext;
  return Math.max(...series.map(({ data }) => data.length));
};
